
/*
 * 	Created By: Caitlyne Mendes - May 8, 2018
 *  
 *  Description: Dynamic dropdown selection for the custom meter build. Coded with JavaScript and jQuery. Referenced in theme.liquid, product-socket-form.liquid. This script logic assumes all meters are sealable. 
 *               This code is longer than the previous one, though for the customer/user it's less steps and easier for them.
 * 				 Jaws and Meter Models are ALWAYS automatically selected in this script, the most a user would have to select are: volts/amps, meter form, pulse output and seal.
 * Changes made: 
 * February 19, 2019 - Caitlyne Mendes - Cleaned code, modified some socket models based on AO. 
 * November 30, 2018 - Gabriel Quiroz & Raj Patel - Remade the whole script due to the renaming of the meter parts, change of logic, volts/amps change.
 * June 8, 2018 - Additional edits done by Carson - Store Tasker
 */

//Initializing variables: These variables store each of the user's selection which will be used for the conditional logic further into the code
var jaws, mForm, volts, pulse, meter, seal;

$(function () {
	//Used for adding the selected socket meter into the cart
	var id = [];
	var qty = [];
	//Since more code would be required to dynamically show each meter form selected, the user has the option to view all the meter forms (image format) in a new window.
	//Not every user would need to view the meter form so it makes it cleaner.
	$("#viewMForm").click(function () {
		window.open('https://cdn.shopify.com/s/files/1/1812/5891/files/meter-form.png?81046382767465455', 'Intellimeter | Meter Form List', 'width=660, height=645');
		return false;
	});
	/*	
	 *	On any of the dropdown menu changes, this event will rewrite the text with the new selected value.
	 * 	These values are stored in the variables created in the .js file, and new selected values overwrite the variable each time.
	 * 	Used an interpolated string to avoid concatinating it with the chars `` in place of "".
	 */
	$('.line-item-property__field').change(function () {
		$('#selected').empty().append(`Volts/Amps: ${volts}<br />Meter Form: ${mForm}<br />Jaws: ${jaws}<br />Pulse Output: ${pulse}<br />Meter: ${meter}<br />Seal: ${seal}<br />`);
		$('#nonsealable').empty();
			//Meter selection
	//Adds the variant to the array or notifies the user of their selection if they chose a meter which doesnt have a seal option yet.
	//This part will be long due to the amount of meter variants. The non-sealable options will also be included, though commented out and the customer will be notified of their selection.
	switch (meter) {
		case "ICI29VM-XT-16S-7J-120to480V-200A":
			id[1] = "15273859547190";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-5S-8J-120to480V-20A-PO-S":
			id[1] = "8884365099062";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-16S-7J-120to480V-200A-S":
			id[1] = "8884365066294";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-ST-1S-4J-120V-100A-PO":
			id[1] = "8883359940662";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-ST-1S-4J-120V-100A":
			id[1] = "8884363821110";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-ST-1S-4J-120V-100A-S":
			id[1] = "8884363755574";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-1S-4J-120to480V-100A":
			id[1] = "8884363886646";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-1S-4J-120to480V-200A":
			id[1] = "8884364214326";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-ST-2S-4J-240V-200A-PO":
			id[1] = "8884364247094";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-ST-2S-4J-240V-200A":
			id[1] = "8884364312630";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-ST-2S-4J-240V-200A-S":
			id[1] = "8884364279862";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-2S-4J-120to480V-200A-PO":
			id[1] = "8884364345398";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-2S-4J-120to480V-200A":
			id[1] = "8884364378166";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-ST-3S-5J-240V-20A-PO":
			id[1] = "8884364410934";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-ST-3S-5J-240V-20A":
			id[1] = "8884364443702";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-3S-5J-120to480V-20A": 
			id[1] = "8884364476470";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
		break;			
		case "ICI29VM-ST-12S-5J-120V-200A-PO":
			id[1] = "8884364509238";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-ST-12S-5J-120V-200A":
			id[1] = "8884364574774";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-ST-12S-5J-120V-200A-S":
			id[1] = "8884364542006";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-12S-5J-120to480V-200A-PO":
			id[1] = "8884364607542";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-12S-5J-120to480V-200A":
			id[1] = "8884364640310";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29ACL-KV2C+12S-5J-600V-200A-PO":
			id[1] = "8884364673078";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29ACL-KV2C+12S-5J-600V-200A-PO-S":
			id[1] = "8884364705846";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29ACL-KV2C+12S-5J-600V-200A":
			id[1] = "19064863227958";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29INTELLA5-25S-5J-208V-200A-PO":
			id[1] = "8884364771382";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29INTELLA5-25S-5J-208V-200A-PO-S":
			id[1] = "8884364738614";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29INTELLA5-25S-5J-208V-200A":
			id[1] = "8884364836918";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29INTELLA5-25S-5J-208V-200A-S":
			id[1] = "8884364804150";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-ST-4S-6J-240V-20A-PO":
			id[1] = "8884364869686";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-ST-4S-6J-240V-20A":
			id[1] = "8884364902454";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-4S-6J-120to480V-20A":
			id[1] = "8884364935222";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-5S-8J-120to480V-20A-PO":
			id[1] = "8884364967990";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-5S-8J-120to480V-20A":
			id[1] = "8884365000758";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-16S-7J-120to480V-200A-PO":
			id[1] = "8884365033526";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-16S-7J-120-480V-200A":
			id[1] = "8884365262902";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-16S-7J-120-480V-200A-S":
			id[1] = "8884365295670";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-6S-13J-120to480V-20A-PO":
			id[1] = "15273859579958";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-6S-13J-120to480V-20A":
			id[1] = "15329557250102";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-9S-13J-120to480V-20A-PO":
			id[1] = "15329557315638";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;
		case "ICI29VM-XT-9S-13J-120to480V-20A":
			id[1] = "15329558036534";
			$('#nonsealable').html('<b><font color="green">' + meter + '</font></b>');
			break;

		case "ICI29VM-ST-1S-4J-120V-100A-PO-S":
		case "ICI29VM-XT-1S-4J-120to480V-100A-S":
		case "ICI29VM-XT-1S-4J-120to480V-200A-S":
		case "ICI29VM-ST-2S-4J-240V-200A-PO-S":
		case "ICI29VM-XT-2S-4J-120to480V-200A-PO-S":
		case "ICI29VM-XT-2S-4J-120to480V-200A-S":
		case "ICI29VM-ST-12S-5J-120V-200A-PO-S":
		case "ICI29VM-XT-12S-5J-120to480V-200A-PO-S":
		case "ICI29VM-XT-12S-5J-120to480V-200A-S":
		case "ICI29ACL-KV2C+12S-5J-600V-200A-S":
		case "ICI29VM-XT-16S-7J-120to480V-200A-PO-S":
		case "ICI29VM-XT-9S-13J-120to480V-20A-PO-S":
		case "ICI29VM-XT-9S-13J-120to480V-20A-S":
			$('#nonsealable').html('<b><font color="red">SEALING NOT APPROVED</font></b>. Please choose the non-sealed version of this socket meter or another meter model.');
			break;
		default:		break;
	}
	});

	// The dynamic dropdown acts like the waterfall effect. The user won't be able to complete the form unless all choices are selected.
	// Jaws are AUTOMATICALLY selected once the meter form is chosen.
	$('#voltsamps').change(function () {
		//Hide meter dropdown/sealing approval text once they start the form - Feb 19/19.
		$('#meter').empty();
		$('#meter').hide();
		$('#meter-selected').text('Complete your selections to determine what socket meter is right for you!');
		$('#nonsealable').empty();

		volts = $('#voltsamps').val();
		$('#meter-form').empty();
		$('#jaws').empty();
		$('#pulse-output').empty();
		$('#seal').empty();
		switch (volts) {
			//One variant (Auto-selects up to meter, prompt for seal)
			case '120-347V/100A Auto Ranging':
				$('#meter-form').append('<option value="1s" selected>1s</option>');
				mForm = $('#meter-form option:selected').val();
				$('#meter-form').val(mForm);

				$('#jaws').append('<option value="4" selected>4</option>');
				jaws = $('#jaws option:selected').val();
				$('#jaws').val(jaws);

				$('#pulse-output').append('<option value="No" selected>No</option>');
				pulse = $('#pulse-output option:selected').val();
				$('#pulse-output').val(pulse);

				$('#meter').append('<option value="ICI29VM-XT-1S-4J-120to480V-100A" selected>ICI29VM-XT-1S-4J-120to480V-100A</option>');
				meter = $('#meter option:selected').val();
				$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 1S, 4 jaw 120 to 480 Volts self adjust 100 amps.');
				$('#txtMeter').val(meter);

				$('#seal').append('<option value="" disabled selected>Please Select...</option>');
				$('#seal').append('<option value="Yes">Yes</option>');
				$('#seal').append('<option value="No">No</option>');
				seal = $('#seal option:selected').val();
				$('#seal').val(seal);
				break;

			//Two variants (Prompt for pulse output, seal)
			case '120V/100A Fixed':
				$('#meter-form').append('<option value="1s" selected>1s</option>');
				mForm = $('#meter-form option:selected').val();
				$('#meter-form').val(mForm);

				$('#jaws').append('<option value="4" selected>4</option>');
				jaws = $('#jaws option:selected').val();
				$('#jaws').val(jaws);

				$('#pulse-output').append('<option value="" disabled selected>Please Select...</option>');
				$('#pulse-output').append('<option value="Yes">Yes</option>');
				$('#pulse-output').append('<option value="No">No</option>');
				break;

			case '240V/200A Fixed':
				$('#meter-form').append('<option value="2s" selected>2s</option>');
				mForm = $('#meter-form option:selected').val();
				$('#meter-form').val(mForm);

				$('#jaws').append('<option value="4" selected>4</option>');
				jaws = $('#jaws option:selected').val();
				$('#jaws').val(jaws);

				$('#pulse-output').append('<option value="" disabled selected>Please Select...</option>');
				$('#pulse-output').append('<option value="Yes">Yes</option>');
				$('#pulse-output').append('<option value="No">No</option>');
				break;

			//Both are 12s 5J.
			case '600V/200A Fixed':
			case '120V/200A Fixed':
				$('#meter-form').append('<option value="12s" selected>12s</option>');
				mForm = $('#meter-form option:selected').val();
				$('#meter-form').val(mForm);

				$('#jaws').append('<option value="5" selected>5</option>');
				jaws = $('#jaws option:selected').val();
				$('#jaws').val(jaws);

				$('#pulse-output').append('<option value="" disabled selected>Please Select...</option>');
				$('#pulse-output').append('<option value="Yes">Yes</option>');
				$('#pulse-output').append('<option value="No">No</option>');
				break;

			case '208V/200A Fixed':
				$('#meter-form').append('<option value="25s">25s</option>');
				mForm = $('#meter-form option:selected').val();
				$('#meter-form').val(mForm);

				$('#jaws').append('<option value="5" selected>5</option>');
				jaws = $('#jaws option:selected').val();
				$('#jaws').val(jaws);

				$('#pulse-output').append('<option value="" disabled selected>Please Select...</option>');
				$('#pulse-output').append('<option value="Yes">Yes</option>');
				$('#pulse-output').append('<option value="No">No</option>');
				break;

			//Four Variants (Prompt for meter form, pulse output, seal)
			//since these two meter forms have different jaws, they get declared on the meter form function instead.  
			case '240V/20A Fixed':
				$('#meter-form').append('<option value="" disabled selected>Please Select...</option>');
				$('#meter-form').append('<option value="3s">3s</option>');
				$('#meter-form').append('<option value="4s">4s</option>');
				break;

			//Eight Variants (Prompt for meter form, pulse output, seal)
			case '120-347V/200A Auto Ranging':
				$('#meter-form').append('<option value="" disabled selected>Please Select...</option>');
				$('#meter-form').append('<option value="1s">1s</option>');
				$('#meter-form').append('<option value="2s">2s</option>');
				$('#meter-form').append('<option value="12s">12s</option>');
				$('#meter-form').append('<option value="16s">16s</option>');
				break;

			case '120-347V/20A Auto Ranging':
				$('#meter-form').append('<option value="" disabled selected>Please Select...</option>');
				$('#meter-form').append('<option value="3s">3s</option>');
				$('#meter-form').append('<option value="4s">4s</option>');
				$('#meter-form').append('<option value="5s">5s</option>');
				$('#meter-form').append('<option value="6s">6s</option>');
				$('#meter-form').append('<option value="9s">9s</option>');
				break;
			default:
				break;
		}
	});

	$('#meter-form').change(function () {
		mForm = $('#meter-form').val();
		$('#jaws').empty();
		$('#pulse-output').empty();
		$('#seal').empty();
		switch (mForm) {
			case '1s':
				$('#jaws').append('<option value="4" selected>4</option>');
				jaws = $('#jaws option:selected').val();
				$('#jaws').val(jaws);

				$('#pulse-output').append('<option value="No" selected>No</option>');
				pulse = $('#pulse-output option:selected').val();
				$('#pulse-output').val(pulse);

				if (volts === "120-347V/200A Auto Ranging") {
					$('#seal').append('<option value="" disabled selected>Please Select...</option>');
					$('#seal').append('<option value="Yes">Yes</option>');
					$('#seal').append('<option value="No">No</option>');
					seal = $('#seal option:selected').val();
					$('#seal').val(seal);
				}
				break;
			case '2s':
				$('#jaws').append('<option value="4" selected>4</option>');
				jaws = $('#jaws option:selected').val();
				$('#jaws').val(jaws);

				$('#pulse-output').append('<option value="" disabled selected>Please Select...</option>');
				$('#pulse-output').append('<option value="Yes">Yes</option>');
				$('#pulse-output').append('<option value="No">No</option>');
				break;
			case '3s':
				$('#jaws').append('<option value="5" selected>5</option>');
				jaws = $('#jaws option:selected').val();
				$('#jaws').val(jaws);

				if (volts === "120-347V/20A Auto Ranging") {
					$('#pulse-output').append('<option value="No" selected>No</option>');
					pulse = $('#pulse-output option:selected').val();
					$('#pulse-output').val(pulse);
					
					$('#seal').append('<option value="No" selected>No</option>');
					seal = $('#seal option:selected').val();
					$('#seal').val(seal);
					
					$('#meter').append('<option value="ICI29VM-XT-3S-5J-120to480V-20A" selected>ICI29VM-XT-3S-5J-120to480V-20A</option>');
					meter = $('#meter option:selected').val();
					$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 3S, 5 jaw 120 to 480 Volts self adjust 20 Amps (requires external CTs).');
					$('#txtMeter').val(meter);
				} else {
					$('#pulse-output').append('<option value="" selected>Please Select...</option>');
					$('#pulse-output').append('<option value="Yes">Yes</option>');
					$('#pulse-output').append('<option value="No">No</option>');
				}

				
				break;
			case '4s':
				if (volts === "120-347V/20A Auto Ranging") {
					$('#jaws').append('<option value="5" selected>5</option>');
					jaws = $('#jaws option:selected').val();
					$('#jaws').val(jaws);

					$('#pulse-output').append('<option value="No" selected>No</option>');
					pulse = $('#pulse-output option:selected').val();
					$('#pulse-output').val(pulse);

					$('#seal').append('<option value="No" selected>No</option>');
					seal = $('#seal option:selected').val();
					$('#seal').val(seal);

					$('#meter').append('<option value="ICI29VM-XT-4S-6J-120to480V-20A" selected>ICI29VM-XT-4S-6J-120to480V-20A</option>');
					meter = $('#meter option:selected').val();
					$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 4S, 6 jaw 120 to 480 Volts  20 Amps (requires external CTs).');
					$('#txtMeter').val(meter);
				}

				if (volts === "240V/20A Fixed") {
					$('#jaws').append('<option value="6" selected>6</option>');
					jaws = $('#jaws option:selected').val();
					$('#jaws').val(jaws);

					$('#pulse-output').append('<option value="" disabled selected>Please Select...</option>');
					$('#pulse-output').append('<option value="Yes">Yes</option>');
					$('#pulse-output').append('<option value="No">No</option>');
				}
				break;

			case '12s':
				$('#jaws').append('<option value="5" selected>5</option>');
				jaws = $('#jaws option:selected').val();
				$('#jaws').val(jaws);

				if (volts === "120-347V/20A Auto Ranging") {
					$('#pulse-output').append('<option value="No" selected>No</option>');
					pulse = $('#pulse-output option:selected').val();
					$('#pulse-output').val(pulse);

					$('#seal').append('<option value="" disabled selected>Please Select...</option>');
					$('#seal').append('<option value="Yes">Yes</option>');
					$('#seal').append('<option value="No">No</option>');
					seal = $('#seal option:selected').val();
					$('#seal').val(seal);
				}
				else {
					$('#pulse-output').append('<option value="" disabled selected>Please Select...</option>');
					$('#pulse-output').append('<option value="Yes">Yes</option>');
					$('#pulse-output').append('<option value="No">No</option>');
				}
				break;
			case '5s':
				$('#jaws').append('<option value="8" selected>8</option>');
				jaws = $('#jaws option:selected').val();
				$('#jaws').val(jaws);
				$('#pulse-output').append('<option value="" disabled selected>Please Select...</option>');
				$('#pulse-output').append('<option value="Yes">Yes</option>');
				$('#pulse-output').append('<option value="No">No</option>');
				break;

			case '4s':
				$('#jaws').append('<option value="6" selected>6</option>');
				jaws = $('#jaws option:selected').val();
				$('#jaws').val(jaws);

				$('#pulse-output').append('<option value="No" selected>No</option>');
				pulse = $('#pulse-output option:selected').val();
				$('#pulse-output').val(pulse);

				$('#seal').append('<option value="" disabled selected>Please Select...</option>');
				$('#seal').append('<option value="Yes">Yes</option>');
				$('#seal').append('<option value="No">No</option>');
				seal = $('#seal option:selected').val();
				$('#seal').val(seal);
				break;
			case '6s':
			case '9s':
				$('#jaws').append('<option value="13" selected>13</option>');
				jaws = $('#jaws option:selected').val();
				$('#jaws').val(jaws);

				$('#pulse-output').append('<option value="" disabled selected>Please Select...</option>');
				$('#pulse-output').append('<option value="Yes">Yes</option>');
				$('#pulse-output').append('<option value="No">No</option>');
				break;

			case '16s':
				$('#jaws').append('<option value="7" selected>7</option>');
				jaws = $('#jaws option:selected').val();
				$('#jaws').val(jaws);

				$('#pulse-output').append('<option value="" disabled selected>Please Select...</option>');
				$('#pulse-output').append('<option value="Yes">Yes</option>');
				$('#pulse-output').append('<option value="No">No</option>');
				break;
			default:
				break;
		}
	});

	$('#pulse-output').change(function () {
		pulse = $('#pulse-output :selected').val();
		$('#meter').empty();
		$('#seal').empty();
		switch (volts) {
			//Two Variants (prompt for pulse output, seal)
			case '120V/100A Fixed':
				if (pulse === 'Yes') {
					$('#meter').append('<option value="ICI29VM-ST-1S-4J-120V-100A-PO" selected>ICI29VM-ST-1S-4J-120V-100A-PO</option>');
					meter = $('#meter option:selected').val();
					$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision ST Form 1S, 4 jaw 120Volts 100 Amps Pulse Output.');
					$('#txtMeter').val(meter);

					$('#seal').append('<option value="" disabled selected>Please Select...</option>');
					$('#seal').append('<option value="Yes">Yes</option>');
					$('#seal').append('<option value="No">No</option>');
				} else {
					$('#meter').append('<option value="ICI29VM-ST-1S-4J-120V-100A" selected>ICI29VM-ST-1S-4J-120V-100A</option>');
					meter = $('#meter option:selected').val();
					$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision ST Form 1S, 4 jaw 120Volts 100 Amps.');
					$('#txtMeter').val(meter);

					$('#seal').append('<option value="" disabled selected>Please Select...</option>');
					$('#seal').append('<option value="Yes">Yes</option>');
					$('#seal').append('<option value="No">No</option>');
				}
				break;

			case '240V/200A Fixed':
				if (pulse === 'Yes') {
					$('#meter').append('<option value="ICI29VM-ST-2S-4J-240V-200A-PO" selected>ICI29VM-ST-2S-4J-240V-200A-PO</option>');
					meter = $('#meter option:selected').val();
					$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision ST Form 2S, 4 jaw 240 Volts 200 Amps with Pulse Output.');
					$('#txtMeter').val(meter);

					$('#seal').append('<option value="" disabled selected>Please Select...</option>');
					$('#seal').append('<option value="Yes">Yes</option>');
					$('#seal').append('<option value="No">No</option>');
				} else {
					$('#meter').append('<option value="ICI29VM-ST-2S-4J-240V-200A" selected>ICI29VM-ST-2S-4J-240V-200A</option>');
					meter = $('#meter option:selected').val();
					$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision ST Form 2S, 4 jaw 240 Volts 200 Amps.');
					$('#txtMeter').val(meter);

					$('#seal').append('<option value="" disabled selected>Please Select...</option>');
					$('#seal').append('<option value="Yes">Yes</option>');
					$('#seal').append('<option value="No">No</option>');
				}
				break;

			case '600V/200A Fixed':
				if (pulse === 'Yes') {
					$('#meter').append('<option value="ICI29ACL-KV2C+12S-5J-600V-200A-PO" selected>ICI29ACL-KV2C+12S-5J-600V-200A-PO</option>');
					meter = $('#meter option:selected').val();
					$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Aclara KV2C Form 12S, 5 jaw 600 Volts  200 Amps with Pulse Output.');
					$('#txtMeter').val(meter);

					$('#seal').append('<option value="" disabled selected>Please Select...</option>');
					$('#seal').append('<option value="Yes">Yes</option>');
					$('#seal').append('<option value="No">No</option>');
				} else {
					$('#meter').append('<option value="ICI29ACL-KV2C+12S-5J-600V-200A" selected>ICI29ACL-KV2C+12S-5J-600V-200A</option>');
					meter = $('#meter option:selected').val();
					$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Aclara KV2C Form 12S, 5 jaw 600 Volts  200 Amps');
					$('#txtMeter').val(meter);

					$('#seal').append('<option value="" disabled selected>Please Select...</option>');
					$('#seal').append('<option value="Yes">Yes</option>');
					$('#seal').append('<option value="No">No</option>');
				}
				break;

			case '120V/200A Fixed':
				if (pulse === 'Yes') {
					$('#meter').append('<option value="ICI29VM-ST-12S-5J-120V-200A-PO" selected>ICI29VM-ST-12S-5J-120V-200A-PO</option>');
					meter = $('#meter option:selected').val();
					$('#meter-selected').text('Based off your selections, your meter is the ICI29VM-ST-12S-5J-120V-200A-PO.');
					$('#txtMeter').val(meter);


					$('#seal').append('<option value="" disabled selected>Please Select...</option>');
					$('#seal').append('<option value="Yes">Yes</option>');
					$('#seal').append('<option value="No">No</option>');
				} else {
					$('#meter').append('<option value="ICI29VM-ST-12S-5J-120V-200A" selected>ICI29VM-ST-12S-5J-120V-200A</option>');
					meter = $('#meter option:selected').val();
					$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision ST Form 12S, 5 jaw 120 Volts 200 Amps.');
					$('#txtMeter').val(meter);

					$('#seal').append('<option value="" disabled selected>Please Select...</option>');
					$('#seal').append('<option value="Yes">Yes</option>');
					$('#seal').append('<option value="No">No</option>');
				}
				break;

			case '208V/200A Fixed':
				if (pulse === 'Yes') {
					$('#meter').append('<option value="ICI29INTELLA5-25S-5J-208V-200A-PO" selected>ICI29INTELLA5-25S-5J-208V-200A-PO</option>');
					meter = $('#meter option:selected').val();
					$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Intella 5  Form 25S, 5 Jaw 208 Volts 200 Amp with Pulse Output and MC Seal.');
					$('#txtMeter').val(meter);

					$('#seal').append('<option value="" disabled selected>Please Select...</option>');
					$('#seal').append('<option value="Yes">Yes</option>');
					$('#seal').append('<option value="No">No</option>');
				} else {
					$('#meter').append('<option value="ICI29INTELLA5-25S-5J-208V-200A" selected>ICI29INTELLA5-25S-5J-208V-200A</option>');
					meter = $('#meter option:selected').val();
					$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Intella 5  Form 25S, 5 Jaw 208 Volts 200 Amp  MC Seal .');
					$('#txtMeter').val(meter);

					$('#seal').append('<option value="" disabled selected>Please Select...</option>');
					$('#seal').append('<option value="Yes">Yes</option>');
					$('#seal').append('<option value="No">No</option>');
				}
				break;

			//Four Variants (Prompt for meter form, pulse output, seal)
			//Determine meter model from previous selections using the meter form selection.            

			//No sealing options for these meters.	
			case '240V/20A Fixed':
				if (mForm === '3s') {
						$('#seal').append('<option value="No" selected>No</option>');
						seal = $('#seal option:selected').val();
						$('#seal').val(seal);

						$('#meter').append('<option value="ICI29VM-ST-3S-5J-240V-20A" selected>ICI29VM-ST-3S-5J-240V-20A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision ST Form 3S, 5 jaw 240 Volts 20 Amps (requires external CTs).');
						$('#txtMeter').val(meter);
				}
				else if (mForm === '4s') {
					if (pulse === 'Yes') {
						$('#seal').append('<option value="No" selected>No</option>');
						seal = $('#seal option:selected').val();
						$('#seal').val(seal);

						$('#meter').append('<option value="ICI29VM-ST-4S-6J-240V-20A-PO" selected>ICI29VM-ST-4S-6J-240V-20A-PO</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision ST Form 4S, 6 jaw 240 Volts  20 Amps with Pulse Output (requires external CTs).');
						$('#txtMeter').val(meter);
					} else {
						$('#seal').append('<option value="No" selected>No</option>');
						seal = $('#seal option:selected').val();
						$('#seal').val(seal);

						$('#meter').append('<option value="ICI29VM-ST-4S-6J-240V-20A" selected>ICI29VM-ST-4S-6J-240V-20A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision ST Form 4S, 6 jaw 240 Volts 20 Amps (requires external CTs)');
						$('#txtMeter').val(meter);
					}
				}
				break;

			//Eight Variants
			case '120-347V/200A Auto Ranging':
			switch (mForm) {
				case '1s':
					$('#seal').append('<option value="" disabled selected>Please Select...</option>');
					$('#seal').append('<option value="Yes">Yes</option>');
					$('#seal').append('<option value="No">No</option>');

					$('#meter').append('<option value="ICI29VM-XT-1S-4J-120to480V-200A" selected>ICI29VM-XT-1S-4J-120to480V-200A</option>');
					meter = $('#meter option:selected').val();
					$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 1S, 4 jaw 120 to 480 Volts self adjust 200 Amps.');
					$('#txtMeter').val(meter);
					break;

				case '2s':
					if (pulse === 'Yes') {
						$('#seal').append('<option value="" disabled selected>Please Select...</option>');
						$('#seal').append('<option value="Yes">Yes</option>');
						$('#seal').append('<option value="No">No</option>');

						$('#meter').append('<option value="ICI29VM-XT-2S-4J-120to480V-200A-PO" selected>ICI29VM-XT-2S-4J-120to480V-200A-PO</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 2S, 4 jaw 120 to 480 Volts self adjust 200 Amps with Pulse Output.');
						$('#txtMeter').val(meter);
					} else {
						$('#seal').append('<option value="" disabled selected>Please Select...</option>');
						$('#seal').append('<option value="Yes">Yes</option>');
						$('#seal').append('<option value="No">No</option>');

						$('#meter').append('<option value="ICI29VM-XT-2S-4J-120to480V-200A" selected>ICI29VM-XT-2S-4J-120to480V-200A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 2S, 4 jaw 120 to 480 Volts self adjust 200 Amps.');
						$('#txtMeter').val(meter);
					}
					break;

				case '12s':
					if (pulse === 'Yes') {
						$('#seal').append('<option value="" disabled selected>Please Select...</option>');
						$('#seal').append('<option value="Yes">Yes</option>');
						$('#seal').append('<option value="No">No</option>');

						$('#meter').append('<option value="ICI29VM-XT-12S-5J-120to480V-200A-PO" selected>ICI29VM-XT-12S-5J-120to480V-200A-PO</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the ICI29VM-XT-12S-5J-120to480V-200A-PO.');
						$('#txtMeter').val(meter);
					} else {
						$('#seal').append('<option value="" disabled selected>Please Select...</option>');
						$('#seal').append('<option value="Yes">Yes</option>');
						$('#seal').append('<option value="No">No</option>');

						$('#meter').append('<option value="ICI29VM-XT-12S-5J-120to480V-200A" selected>ICI29VM-XT-12S-5J-120to480V-200A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 12S, 5 jaw 120 to 480 Volts self adjust 200 Amps.');
						$('#txtMeter').val(meter);
					}
					break;

				case '16s':
					if (pulse === 'Yes') {
						$('#seal').append('<option value="" disabled selected>Please Select...</option>');
						$('#seal').append('<option value="Yes">Yes</option>');
						$('#seal').append('<option value="No">No</option>');

						$('#meter').append('<option value="ICI29VM-XT-16S-7J-120to480V-200A-PO" selected>ICI29VM-XT-16S-7J-120to480V-200A-PO</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 16S, 7 jaw 120 to 480 Volts 200 Amps with Pulse Output.');
						$('#txtMeter').val(meter);
					} else {
						$('#seal').append('<option value="" disabled selected>Please Select...</option>');
						$('#seal').append('<option value="Yes">Yes</option>');
						$('#seal').append('<option value="No">No</option>');

						$('#meter').append('<option value="ICI29VM-XT-16S-7J-120to480V-200A" selected>ICI29VM-XT-16S-7J-120to480V-200A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 16S, 7 jaw 120 to 480 Volts 200 Amps.');
						$('#txtMeter').val(meter);
					}
					break;
			}
				break;

			case '120-347V/20A Auto Ranging':
				switch (mForm) {
					case '3s':
						$('#seal').append('<option value="No" selected>No</option>');
						seal = $('#seal option:selected').val();
						$('#seal').val(seal);
						break;

					case '4s':
						$('#seal').append('<option value="No" selected>No</option>');
						seal = $('#seal option:selected').val();
						$('#seal').val(seal);
						
						$('#meter').append('<option value="ICI29VM-XT-4S-6J-120to480V-20A" selected>ICI29VM-XT-4S-6J-120to480V-20A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 4S, 6 jaw 120 to 480 Volts 20 Amps (requires external CTs).');
						$('#txtMeter').val(meter);
						break;

					case '5s':
						if (pulse === 'Yes') {
							$('#seal').append('<option value="No" selected>No</option>');
							seal = $('#seal option:selected').val();
							$('#seal').val(seal);

							$('#meter').append('<option value="ICI29VM-XT-5S-8J-120to480V-20A-PO" selected>ICI29VM-XT-5S-8J-120to480V-20A-PO</option>');
							meter = $('#meter option:selected').val();
							$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 5S, 8 jaw 120 to 480 Volts  20 Amps with Pulse Output (requires external CTs).');
							$('#txtMeter').val(meter);

						} else {
							$('#seal').append('<option value="No" selected>No</option>');
							seal = $('#seal option:selected').val();
							$('#seal').val(seal);
							
							$('#meter').append('<option value="ICI29VM-XT-5S-8J-120to480V-20A" selected>ICI29VM-XT-5S-8J-120to480V-20A</option>');
							meter = $('#meter option:selected').val();
							$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 5S, 8 jaw 120 to 480 Volts  20 Amps (requires external CTs).');
							$('#txtMeter').val(meter);
						}
						break;
					case '6s':
						if (pulse === 'Yes') {
							$('#seal').append('<option value="No" selected>No</option>');
							seal = $('#seal option:selected').val();
							$('#seal').val(seal);
							
							$('#meter').append('<option value="ICI29VM-XT-6S-13J-120to480V-20A-PO" selected>ICI29VM-XT-6S-13J-120to480V-20A-PO</option>');
							meter = $('#meter option:selected').val();
							$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 6S, 13 jaw 120 to 480 Volts 20 Amps with Pulse Output (requires external CTs).');
							$('#txtMeter').val(meter);
						} else {
							$('#seal').append('<option value="No" selected>No</option>');
							seal = $('#seal option:selected').val();
							$('#seal').val(seal);

							$('#meter').append('<option value="ICI29VM-XT-6S-13J-120to480V-20A" selected>ICI29VM-XT-6S-13J-120to480V-20A</option>');
							meter = $('#meter option:selected').val();
							$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 6S, 13 jaw 120 to 480 Volts 20 Amps (requires external CTs).');
							$('#txtMeter').val(meter);
							}
						break;

					case '9s':
						if (pulse === 'Yes') {
						$('#seal').append('<option value="" disabled selected>Please Select...</option>');
						$('#seal').append('<option value="Yes">Yes</option>');
						$('#seal').append('<option value="No">No</option>');
							
						$('#meter').append('<option value="ICI29VM-XT-9S-13J-120to480V-20A" selected>ICI29VM-XT-9S-13J-120to480V-20A/option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 9S, 13 jaw 120 to 480 Volts 20 Amps (requires external CTs).');
						$('#txtMeter').val(meter);
							
						} else {
							$('#seal').append('<option value="" disabled selected>Please Select...</option>');
							$('#seal').append('<option value="Yes">Yes</option>');
							$('#seal').append('<option value="No">No</option>');
							
							$('#meter').append('<option value="ICI29VM-XT-9S-13J-120to480V-20A-PO" selected>ICI29VM-XT-9S-13J-120to480V-20A-PO</option>');
							meter = $('#meter option:selected').val();
							$('#meter-selected').text('Socket Meter Vision XT Form 9S, 13 jaw 120 to 480 Volts 20 Amps with Pulse Output (requires external CTs).');
							$('#txtMeter').val(meter);
						}
						break;
					default:
						break;
				}//end of switch in '120-347V/20A Auto Ranging'
				break;
				default:break;
		}
	});

$('#seal').change(function () {
	seal = $('#seal').val();
	$('#meter').empty();
	switch (volts) {
		//One Variant (Auto-selects up to meter, prompt for seal)
		case '120-347V/100A Auto Ranging':
			if (seal === "Yes") {
				$('#meter').append('<option value="ICI29VM-XT-1S-4J-120to480V-100A-S" selected>ICI29VM-XT-1S-4J-120to480V-100A-S</option>');
				meter = $('#meter option:selected').val();
				$('#meter-selected').text('This meter is not available for purchase. Please contact us for more details.');
				$('#txtMeter').val(meter);
			} else {
				$('#meter').append('<option value="ICI29VM-XT-1S-4J-120to480V-100A" selected>ICI29VM-XT-1S-4J-120to480V-100A</option>');
				meter = $('#meter option:selected').val();
				$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 1S, 4 jaw 120 to 480 Volts self adjust 100 amps.');
				$('#txtMeter').val(meter);
			}
			break;

		//Two Variants (prompt for pulse output, seal)
		case '120V/100A Fixed':
			switch (pulse) {
				case 'Yes':
					if (seal === 'Yes') {
						//THIS METER WAS REMOVED:ICI29VM-ST-1S-4J-120V-100A-PO-S
						//TEST IN STORE FOR DIRECT SELECTION
						$('#meter').append('<option value="ICI29VM-ST-1S-4J-120V-100A-PO-S" selected>ICI29VM-ST-1S-4J-120V-100A-PO-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('This meter is not available for purchase. Please contact us for more details.');
						$('#txtMeter').val(meter);
					} else {
						$('#meter').append('<option value="ICI29VM-ST-1S-4J-120V-100A-PO" selected>ICI29VM-ST-1S-4J-120V-100A-PO</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision ST Form 1S, 4 jaw 120Volts 100 Amps Pulse Output.');
						$('#txtMeter').val(meter);
					}
					break;
				case 'No':
					if (seal === 'Yes') {
						$('#meter').append('<option value="ICI29VM-ST-1S-4J-120V-100A-S" selected>ICI29VM-ST-1S-4J-120V-100A-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision ST Form 1S, 4 jaw 120Volts 100 Amps - MC Seal.');
						$('#txtMeter').val(meter);
					} else {
						$('#meter').append('<option value="ICI29VM-ST-1S-4J-120V-100A" selected>ICI29VM-ST-1S-4J-120V-100A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision ST Form 1S, 4 jaw 120Volts 100 Amps.');
						$('#txtMeter').val(meter);
					}
					break;
				default:
					break;
			}
			break;

		case '240V/200A Fixed':
			switch (pulse) {
				case 'Yes':
					if (seal === 'Yes') {
						$('#meter').append('<option value="ICI29VM-ST-2S-4J-240V-200A-PO-S" selected>ICI29VM-ST-2S-4J-240V-200A-PO-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('This meter is not available for purchase. Please contact us for more details.');
						$('#txtMeter').val(meter);
					} else {
						$('#meter').append('<option value="ICI29VM-ST-2S-4J-240V-200A-PO" selected>ICI29VM-ST-2S-4J-240V-200A-PO</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision ST Form 2S, 4 jaw 240 Volts 200 Amps with Pulse Output.');
						$('#txtMeter').val(meter);
					}
					break;
				case 'No':
					if (seal === 'Yes') {
						$('#meter').append('<option value="ICI29VM-ST-2S-4J-240V-200A-S" selected>ICI29VM-ST-2S-4J-240V-200A-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision ST Form 2S, 4 jaw 240 Volts 200 Amps -MC Seal.');
						$('#txtMeter').val(meter);
					} else {
						$('#meter').append('<option value="ICI29VM-ST-2S-4J-240V-200A" selected>ICI29VM-ST-2S-4J-240V-200A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision ST Form 2S, 4 jaw 240 Volts 200 Amps.');
						$('#txtMeter').val(meter);
					}
					break;
				default:
					break;
			}
			break;

		case '600V/200A Fixed':
			switch (pulse) {
				case 'Yes':
					if (seal === 'Yes') {
						$('#meter').append('<option value="ICI29ACL-KV2C+12S-5J-600V-200A-PO-S" selected>ICI29ACL-KV2C+12S-5J-600V-200A-PO-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Aclara KV2C Form 12S, 5 jaw 600 Volts  200 Amps with Pulse Output -MC Seal.');
						$('#txtMeter').val(meter);
					} else {
						$('#meter').append('<option value="ICI29ACL-KV2C+12S-5J-600V-200A-PO" selected>ICI29ACL-KV2C+12S-5J-600V-200A-PO</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Aclara KV2C Form 12S, 5 jaw 600 Volts  200 Amps with Pulse Output.');
						$('#txtMeter').val(meter);
					}
					break;
				case 'No':
					if (seal === 'Yes') {
						$('#meter').append('<option value="ICI29ACL-KV2C+12S-5J-600V-200A-S" selected>ICI29ACL-KV2C+12S-5J-600V-200A-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('This meter is not available for purchase. Please contact us for more details.');
						$('#txtMeter').val(meter);
					} else {
						$('#meter').append('<option value="ICI29ACL-KV2C+12S-5J-600V-200A" selected>ICI29ACL-KV2C+12S-5J-600V-200A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Aclara KV2C Form 12S, 5 jaw 600 Volts  200 Amps');
						$('#txtMeter').val(meter);
					}
					break;
				default:
					break;
			}
			break;

		case '120V/200A Fixed':
			switch (pulse) {
				case 'Yes':
					if (seal === 'Yes') {
						$('#meter').append('<option value="ICI29VM-ST-12S-5J-120V-200A-PO-S" selected>ICI29VM-ST-12S-5J-120V-200A-PO-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('This meter is not available for purchase. Please contact us for more details.');
						$('#txtMeter').val(meter);
					} else {
						$('#meter').append('<option value="ICI29VM-ST-12S-5J-120V-200A-PO" selected>ICI29VM-ST-12S-5J-120V-200A-PO</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision ST Form 12S, 5 jaw 120 Volts 200 Amps with Pulse Output.');
						$('#txtMeter').val(meter);
					}
					break;
				case 'No':
					if (seal === 'Yes') {
						$('#meter').append('<option value="ICI29VM-ST-12S-5J-120V-200A-S" selected>ICI29VM-ST-12S-5J-120V-200A-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision ST Form 12S, 5 jaw 120 Volts 200 Amps MC Seal.');
						$('#txtMeter').val(meter);
					} else {
						$('#meter').append('<option value="ICI29VM-ST-12S-5J-120V-200A" selected>ICI29VM-ST-12S-5J-120V-200A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision ST Form 12S, 5 jaw 120 Volts 200 Amps.');
						$('#txtMeter').val(meter);
					}
					break;
				default:
					break;
			}
			break;
		case '208V/200A Fixed':
			switch (pulse) {
				case 'Yes':
					if (seal === 'Yes') {
						$('#meter').append('<option value="ICI29INTELLA5-25S-5J-208V-200A-PO-S" selected>ICI29INTELLA5-25S-5J-208V-200A-PO-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Intella 5  Form 25S, 5 Jaw 208 Volts 200 Amp with Pulse Output and MC Seal.');
						$('#txtMeter').val(meter);
					} else {
						$('#meter').append('<option value="ICI29INTELLA5-25S-5J-208V-200A-PO" selected>ICI29INTELLA5-25S-5J-208V-200A-PO</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Intella 5  Form 25S, 5 Jaw 208 Volts 200 Amp with Pulse Output.');
						$('#txtMeter').val(meter);
					}
					break;
				case 'No':
					if (seal === 'Yes') {
						$('#meter').append('<option value="ICI29INTELLA5-25S-5J-208V-200A-S" selected>ICI29INTELLA5-25S-5J-208V-200A-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Intella 5  Form 25S, 5 Jaw 208 Volts 200 Amp  MC Seal.');
						$('#txtMeter').val(meter);
					} else {
						$('#meter').append('<option value="ICI29INTELLA5-25S-5J-208V-200A" selected>ICI29INTELLA5-25S-5J-208V-200A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Intella 5  Form 25S, 5 Jaw 208 Volts 200 Amp.');
						$('#txtMeter').val(meter);
					}
					break;
				default:
					break;
			}
			break;

		case '120-347V/200A Auto Ranging':
			switch (mForm) {
				case '1s':
					if (seal === 'Yes') {
						$('#meter').append('<option value="ICI29VM-XT-1S-4J-120to480V-200A-S" selected>ICI29VM-XT-1S-4J-120to480V-200A-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('This meter is not available for purchase. Please contact us for more details.');
						$('#txtMeter').val(meter);
					} else {
						$('#meter').append('<option value="ICI29VM-XT-1S-4J-120to480V-200A" selected>ICI29VM-XT-1S-4J-120to480V-200A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 1S, 4 jaw 120 to 480 Volts self adjust 200 Amps.');
						$('#txtMeter').val(meter);
					}
					break;

				case '2s':
					if (pulse === 'Yes' && seal === 'Yes') {
						$('#meter').append('<option value="ICI29VM-XT-2S-4J-120to480V-200A-PO-S" selected>ICI29VM-XT-2S-4J-120to480V-200A-PO-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('This meter is not available for purchase. Please contact us for more details.');
						$('#txtMeter').val(meter);
					} else if (pulse === 'Yes' && seal === 'No') {
						$('#meter').append('<option value="ICI29VM-XT-2S-4J-120to480V-200A-PO" selected>ICI29VM-XT-2S-4J-120to480V-200A-PO</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 2S, 4 jaw 120 to 480 Volts self adjust 200 Amps with Pulse Output.');
						$('#txtMeter').val(meter);
					} else if (pulse === 'No' && seal === 'Yes') {
						$('#meter').append('<option value="ICI29VM-XT-2S-4J-120to480V-200A-S" selected>ICI29VM-XT-2S-4J-120to480V-200A-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('This meter is not available for purchase. Please contact us for more details.');
						$('#txtMeter').val(meter);
					} else {
						$('#meter').append('<option value="ICI29VM-XT-2S-4J-120to480V-200A" selected>ICI29VM-XT-2S-4J-120to480V-200A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 2S, 4 jaw 120 to 480 Volts self adjust 200 Amps.');
						$('#txtMeter').val(meter);
					}
					break;

				case '12s':
					if (pulse === 'Yes' && seal === 'Yes') {
						$('#meter').append('<option value="ICI29VM-XT-12S-5J-120to480V-200A-PO-S" selected>ICI29VM-XT-12S-5J-120to480V-200A-PO-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('This meter is not available for purchase. Please contact us for more details.');
						$('#txtMeter').val(meter);
					} else if (pulse === 'Yes' && seal === 'No') {

						$('#meter').append('<option value="ICI29VM-XT-12S-5J-120to480V-200A-PO" selected>ICI29VM-XT-12S-5J-120to480V-200A-PO</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 12S, 5 jaw 120 to 480 Volts self adjust 200 Amps with Pulse Output.');
						$('#txtMeter').val(meter);
					} else if (pulse === 'No' && seal === 'Yes') {
						$('#meter').append('<option value="ICI29VM-XT-12S-5J-120to480V-200A-S" selected>ICI29VM-XT-12S-5J-120to480V-200A-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('This meter is not available for purchase. Please contact us for more details.');
						$('#txtMeter').val(meter);

					} else {
						$('#meter').append('<option value="ICI29VM-XT-12S-5J-120to480V-200A" selected>ICI29VM-XT-12S-5J-120to480V-200A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 12S, 5 jaw 120 to 480 Volts self adjust 200 Amps.');
						$('#txtMeter').val(meter);
					}
					break;

				case '16s':
					if (pulse === 'Yes' && seal === 'Yes') {
						$('#meter').append('<option value="ICI29VM-XT-16S-7J-120to480V-200A-PO-S" selected>ICI29VM-XT-16S-7J-120to480V-200A-PO-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('This meter is not available for purchase. Please contact us for more details.');
						$('#txtMeter').val(meter);
					} else if (pulse === 'Yes' && seal === 'No') {
						$('#meter').append('<option value="ICI29VM-XT-16S-7J-120to480V-200A-PO" selected>ICI29VM-XT-16S-7J-120to480V-200A-PO</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 16S, 7 jaw 120 to 480 Volts 200 Amps with Pulse Output.');
						$('#txtMeter').val(meter);
					} else if (pulse === 'No' && seal === 'Yes') {
						$('#meter').append('<option value="ICI29VM-XT-16S-7J-120to480V-200A-S" selected>ICI29VM-XT-16S-7J-120to480V-200A-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 16S, 7 jaw 120 to 480 Volts 200 Amps MC Seal.');
						$('#txtMeter').val(meter);
					} else {
						$('#meter').append('<option value="ICI29VM-XT-16S-7J-120to480V-200A" selected>ICI29VM-XT-16S-7J-120to480V-200A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 16S, 7 jaw 120 to 480 Volts 200 Amps.');
						$('#txtMeter').val(meter);
					}
					break;
				default:
					break;
			}
			break;

		case '120-347V/20A Auto Ranging':
			switch (mForm) {
				case '3s':
						$('#meter').append('<option value="ICI29VM-XT-3S-5J-120to480V-20A" selected>ICI29VM-XT-3S-5J-120to480V-20A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 3S, 5 jaw 120 to 480 Volts self adjust 20 Amps (requires external CTs).');
						$('#txtMeter').val(meter);
					break;
				case '4s':
					$('#seal').empty();
					$('#seal').append('<option value="No" selected>No</option>');
					seal = $('#seal option:selected').val();
					$('#seal').val(seal);

					$('#meter').append('<option value="ICI29VM-XT-4S-6J-120to480V-20A" selected>ICI29VM-XT-4S-6J-120to480V-20A</option>');
					meter = $('#meter option:selected').val();
					$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 4S, 6 jaw 120 to 480 Volts  20 Amps (requires external CTs).');
					$('#txtMeter').val(meter);

					break;
				case '5s':
					if (jaws === '8' && pulse === 'Yes') {
						$('#seal').empty();
						$('#seal').append('<option value="No" selected>No</option>');
						seal = $('#seal option:selected').val();						
						$('#seal').val(seal);
						
						$('#meter').append('<option value="ICI29VM-XT-5S-8J-120to480V-20A-PO" selected>ICI29VM-XT-5S-8J-120to480V-20A-PO</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 5S, 8 jaw 120 to 480 Volts  20 Amps with Pulse Output (requires external CTs).');
						$('#txtMeter').val(meter);
					}
					break;
				case '6s':
					if (pulse === 'Yes' && seal === 'Yes') {
						$('#meter').append('<option value="ICI29VM-XT-6S-13J-120to480V-20A-PO-S" selected>ICI29VM-XT-6S-13J-120to480V-20A-PO-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the ICI29VM-XT-6S-13J-120to480V-20A-PO-S.');
						$('#txtMeter').val(meter);
					} else if (pulse === 'Yes' && seal === 'No') {
						$('#meter').append('<option value="ICI29VM-XT-6S-13J-120to480V-20A-PO" selected>ICI29VM-XT-6S-13J-120to480V-20A-PO</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 6S, 13 jaw 120 to 480 Volts 20 Amps with Pulse Output (requires external CTs).');
						$('#txtMeter').val(meter);
					} else if (pulse === 'No' && seal === 'Yes') {
						$('#meter').append('<option value="ICI29VM-XT-6S-13J-120to480V-20A-S" selected>ICI29VM-XT-6S-13J-120to480V-20A-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the ICI29VM-XT-6S-13J-120to480V-20A-S.');
						$('#txtMeter').val(meter);

					} else {
						$('#meter').append('<option value="ICI29VM-XT-6S-13J-120to480V-20A" selected>ICI29VM-XT-6S-13J-120to480V-20A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 6S, 13 jaw 120 to 480 Volts 20 Amps (requires external CTs).');
						$('#txtMeter').val(meter);
					}
					break;
				case '9s':
					if (pulse === 'Yes' && seal === 'Yes') {
						$('#meter').append('<option value="ICI29VM-XT-9S-13J-120to480V-20A-PO-S" selected>ICI29VM-XT-9S-13J-120to480V-20A-PO-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('This meter is not available for purchase. Please contact us for more details.');
						$('#txtMeter').val(meter);
					} else if (pulse === 'Yes' && seal === 'No') {
						$('#meter').append('<option value="ICI29VM-XT-9S-13J-120to480V-20A-PO" selected>ICI29VM-XT-9S-13J-120to480V-20A-PO</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 9S, 13 jaw 120 to 480 Volts 20 Amps with Pulse Output (requires external CTs).');
						$('#txtMeter').val(meter);
					} else if (pulse === 'No' && seal === 'Yes') {
						$('#meter').append('<option value="ICI29VM-XT-9S-13J-120to480V-20A-S" selected>ICI29VM-XT-9S-13J-120to480V-20A-S</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('This meter is not available for purchase. Please contact us for more details.');
						$('#txtMeter').val(meter);

					} else {
						$('#meter').append('<option value="ICI29VM-XT-9S-13J-120to480V-20A" selected>ICI29VM-XT-9S-13J-120to480V-20A</option>');
						meter = $('#meter option:selected').val();
						$('#meter-selected').text('Based off your selections, your meter is the Socket Meter Vision XT Form 9S, 13 jaw 120 to 480 Volts 20 Amps (requires external CTs).');
						$('#txtMeter').val(meter);
					}
					break;
			}
			break;

		default:
			break;
	}
});


$('#AddSocket').click(function () {
	//Now that the arrays are populated accordingly, add to cart via queued AJAX requests
	//Modified from original code: https://gist.github.com/mig1098/0b0bf19900dce8584331
	//Note: the Quantity on the Socket builder page will only affect the amount of socket meters desired. 
	//So if they put 5 on the Quantity, the cart will add 5 of the socket meter they have instead of 5 product descriptions.
	function AddItem(qty, id) {
		var params = { quantity: qty, id: id };
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			dataType: 'json',
			async: false,
			data: params,
			success: function () {
				if (typeof callback === 'function')
					callback();
			},
			error: function () { }
		});
	}
	//Change quantity accordingly
	qty[1] = $('#socketQty').val();
	AddItem(qty[1], id[1]);
});
		//end of function 
	});


 $("#sealing").change(function() {
      $("#sealing-form").fadeToggle();
  });

  $("#ship-courier").change(function() {
      $("#courier-form").fadeToggle();
  });
  
  $("input[id='courier-number']").keyup(function() {
    $(this).val($(this).val().replace(/^(\d{3})(\d{3})(\d)+$/, "($1) $2-$3"));
});

